import React from 'react';
export function TruthSection() {
  return <section className="w-full bg-white py-20 px-6 md:px-8 border-y border-lavender/20" style={{
    paddingTop: '70px',
    paddingBottom: '70px'
  }} data-id="element-246">
      <div className="max-w-3xl mx-auto text-center md:text-left" data-id="element-247">
        <span className="text-rose-DEFAULT font-bold tracking-wider text-sm uppercase mb-2 block" data-id="element-248">
          La verdad incómoda
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-text mb-8" data-id="element-249">
          No te falta "actitud". <br data-id="element-250" />
          <span className="text-lavender-dark" data-id="element-251">Te falta estructura.</span>
        </h2>

        <div className="space-y-6 text-lg leading-relaxed text-text/80" data-id="element-252">
          <p data-id="element-253">
            Porque el posparto tiene una trampa: cuando más necesitas claridad,
            menos capacidad tienes para decidir.
          </p>

          <p className="font-medium text-text" data-id="element-254">Y ahí es donde todo se rompe:</p>

          <div className="grid gap-4 md:grid-cols-2" data-id="element-255">
            {['abres TikTok y guardas 40 videos que nunca vuelves a ver', 'googleas a las 2am y terminas peor', 'te compras un libro y no pasas de la página 6', "alguien te dice 'duerme cuando el bebé duerma' y te dan ganas de gritar"].map((item, idx) => <div key={idx} className="bg-cream-light p-4 rounded-xl border border-cream-dark" data-id="element-256">
                <p className="text-base" data-id="element-257">{item}</p>
              </div>)}
          </div>

          <div className="mt-8 p-6 bg-rose-light/30 rounded-2xl border border-rose-DEFAULT/20 text-center md:text-left" data-id="element-258">
            <p className="text-xl font-serif italic text-text" data-id="element-259">
              "No porque seas dramática. Porque estás en supervivencia."
            </p>
          </div>
        </div>
      </div>
    </section>;
}